"use server";

/** Open-source stub — no-op, Auth0 app_metadata not available in OSS mode. */
export default async function markOnboardingComplete(): Promise<void> {}
